import VueLib from 'vue'
import merge from 'lodash.merge'
import * as Sentry from '@sentry/browser'

export default function (ctx, inject) {
  /* eslint-disable object-curly-spacing, quote-props, quotes, key-spacing, comma-spacing */
  const config = {
    dsn:"https:\u002F\u002F4de62393d60a4d2aae4ccc3519e94878@sentry.io\u002F1868170",
    environment:"production",
    beforeSend:function(event, hint) {
        function isSafariExtension(event, hint) {
          if (
          !hint ||
          !hint.originalException ||
          !hint.originalException.stack)
          {
            return false;
          }

          if (
          hint.originalException.stack.indexOf('safari-extension:') !== -1)
          {
            return true;
          }

          return false;
        }

        if (isSafariExtension(event)) {
          // Honey extension causes errors, and we're not interested in any errors inside extensions.
          console.log('Safari extension - suppress exception');
          return null;
        }

        // Sentry logs unhelpful exceptions - see https://github.com/getsentry/sentry-javascript/issues/2210.
        if (hint) {
          console.log(
          'Original exception was',
          hint.originalException,
          typeof hint.originalException);

          if (!hint.originalException) {
            // There's basically no info to report, so there's nothing we can do.  Suppress it.
            console.log('No info - suppress exception');
            return null;
            // eslint-disable-next-line
          } else if (hint.originalException.toString().match(/Down for maintenance/)) {
            console.log('Maintenance - suppress exception', this);
            return null;
            // eslint-disable-next-line
          } else if (hint.originalException.toString().match(/Object Not Found Matching Id/)) {
            // This seems to be a spurious error caused by a password manager.  See
            // https://github.com/getsentry/sentry-javascript/issues/3440
            console.log(
            'Suppress Object Not Found Matching Id, probable password manager');

            return null;
          } else if (
          hint.originalException.name &&
          hint.originalException.name === 'TypeError')
          {
            console.log('TypeError');
            if (hint.originalException.message) {
              console.log('Message', hint.originalException.message);

              if (
              hint.originalException.message.match(/_leaflet_pos/) ||
              hint.originalException.message.match(/getPosition/))
              {
                // This exception can happen when a map is still in motion (e.g. zooming) and you navigate away from
                // the page.  So far as I can tell, this is not properly fixed by either leaflet or vue2-leaflet, but
                // causes no real problems, just Sentry clutter.  So suppress it here.
                console.log('Suppress leaflet exception');
                return null;
              } else if (
              hint.originalException.message.match(
              /can't redefine non-configurable property "userAgent"/))

              {
                // This exception happens a lot, and the best guess I can find is that it is a bugged browser
                // extension.
                console.log('Suppress userAgent');
                return null;
              } else if (hint.originalException.message.match(/cancelled/)) {
                // This probably happens due to the user changing their mind and navigating away immediately.
                console.log('Suppress cancelled');
                return null;
              }
            }
          } else if (
          hint.originalException.name &&
          hint.originalException.name === 'ReferenceError')
          {
            console.log('ReferenceError');
            if (hint.originalException.message) {
              console.log('Message', hint.originalException.message);

              if (
              hint.originalException.message.match(
              /Can't find variable: fieldset/))

              {
                // This happens because of an old bug which is now fixed:
                // https://codereview.chromium.org/2343013005
                console.log('Old Chrome fieldset bug');
                return null;
              }
            }
          }
        }

        // Add some more detail if we can.
        if (hint && hint.originalException instanceof Event) {
          event.extra.isTrusted = hint.originalException.isTrusted;
          event.extra.detail = hint.originalException.detail;
          event.extra.type = hint.originalException.type;
        }

        return event;
      },
    release:"37259d02c7ca37764ba82138ae5d848b0bac33fb"
  }

  const runtimeConfigKey = "sentry"
  if (ctx.$config && runtimeConfigKey && ctx.$config[runtimeConfigKey]) {
    merge(config, ctx.$config[runtimeConfigKey].config, ctx.$config[runtimeConfigKey].clientConfig)
  }

  config.integrations = [

  ]

  /* eslint-enable object-curly-spacing, quote-props, quotes, key-spacing, comma-spacing */
  Sentry.init(config)

  inject('sentry', Sentry)
  ctx.$sentry = Sentry
}
